// extracted by mini-css-extract-plugin
export var mt0 = "fp-fq";
export var mt1 = "fp-gq";
export var mt2 = "fp-hq";
export var mt3 = "fp-iq";
export var mt4 = "fp-jq";
export var mt5 = "fp-kq";
export var mt6 = "fp-lq";
export var widgetShare = "fp-mq";
export var widgetShareTitle = "fp-nq";
export var widgetShare__item = "fp-qq";
export var widgetShare__item__icon = "fp-rq";
export var widgetShare__item__link = "fp-sq";
export var widgetShare__item__notification = "fp-tq";
export var widgetShare__list = "fp-pq";
export var widgetShare__title = "fp-oq";